// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import { trackPageview } from "@/analytics";
import Home from "@/pages/Home.vue";
import UserCard from "@/pages/UserCard.vue";
import HelpCenter from "@/pages/HelpCenter.vue";
import Guides from "@/pages/Guides.vue";
import RetentionGuides from "@/pages/RetentionGuides.vue";
import GuideDetail from "@/pages/GuideDetail.vue";
import Contact from "@/pages/Contact.vue";

const routes = [
    { path: '/', name: 'Home', component: Home },
    { path: '/user-card', name: 'UserCard', component: UserCard },
    { path: '/help-center', name: 'HelpCenter', component: HelpCenter },
    { path: '/guides', name: 'Guides', component: Guides },
    { path: '/guides/:slug', name: 'GuideDetail', component: GuideDetail, props: route => ({ collection: 'guides', slug: route.params.slug }) },
    { path: '/retention-guides', name: 'RetentionGuides', component: RetentionGuides },
    { path: '/retention-guides/:slug', name: 'RetentionGuideDetail', component: GuideDetail, props: route => ({ collection: 'retention-guides', slug: route.params.slug }) },
    { path: '/contact', name: 'Contact', component: Contact },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to) {
        if (to.hash) {
            return { el: to.hash, behavior: 'smooth' }
        }
        return { top: 0 }
    },
})

router.afterEach((to) => {
    trackPageview(to.fullPath);
});

export default router
